export default __webpack_public_path__ + "static/media/banner.a6c36b00.png";